<template>
  <div class="z-20 fixed top-0 inset-x-0 p-4" v-if="!clickHide && !isHidden">
    <div class="bg-indigo-600 rounded-lg shadow-lg text-center py-4 lg:px-4 transition-opacity ease-in delay-1000" :class="{'opacity-100 duration-500': shouldShow, 'opacity-0  duration-200': !shouldShow}">
      <div class="items-center text-indigo-100 leading-none lg:rounded-md flex lg:inline-flex" role="alert">
        <span class="font-semibold mr-2 text-left flex-auto text-white">
          {{ $t('conversation.teaser') }}
          <span class="underline cursor-pointer" :class="{ 'animate-pulse': permissionsPending }" @click="requestPermissions">
            {{ $t('conversation.teaserButton') }}
          </span>.
        </span>
      </div>
      <span @click="hide" class="cursor-pointer p-1 rounded-full bg-indigo-500 uppercase text-xs font-bold float-right" style="margin-top: -4px">
        <XCircleIcon class="h-6 w-6 inline-block fill-transparent stroke-white" />
      </span>
    </div>
  </div>
</template>


<script>
import {
  XCircleIcon,
} from '@heroicons/vue/outline'


export default {
  name: 'NotificationPermissionTeaser',
  components: {
    //
    XCircleIcon,
  },
  created() {
    this.checkPermissions();
  },
  methods: {
    requestPermissions() {
      this.permissionsPending = true;
      this.$notification.requestPermission().then((state) => {
        this.state = state;
      });
    },
    checkPermissions() {
      this.state = window.Notification.permission;
    },
    hide() {
      localStorage.setItem('notificationTeaserClosed', '1');
      this.clickHide = true;
    },
  },
  computed: {
    shouldShow() {
      return this.state !== 'granted' && !this.isLoading && !this.isHidden && !this.clickHide;
    },
    isLoading() {
      return this.state === undefined;
    },
    isHidden() {
      return localStorage.getItem('notificationTeaserClosed') === '1';
    }
  },
  watch: {
    shouldShow(value) {
      if (!value) {
        this.hide();
      }
    },
    state(value) {
      if (value !=='default') {
        this.hide();
      }
    },
  },
  data() {
    return {
      permissionsPending: false,
      state: undefined,
      clickHide: false,
    }
  },
}
</script>
